export default "__VITE_ASSET__4cbed83f__"